import localData from '@/common/localdata'
import loginApi from '@/api/login/login.js'
import logoutApi from '@/api/login/logout.js'

// 登录完成后要做的事情
function afterLogin(commit, response) {
  return new Promise((resolve, reject) => {
    if (response.error) {
      reject(new Error('登录失败：' + response.msg))
    }

    const isAdmin = response.data.roles.reduce((carry, item) => {
      return carry || item.id === parseInt(process.env.VUE_APP_ADMIN_ROLE_ID)
    }, false)
    if (!isAdmin) {
      reject(new Error('登录信息不正确!'))
      return
    }

    commit('SET_SESS_ID', localData.set('SessId', response.data.sessid))
    commit('SET_USER_DATA', localData.set('UserData', response.data.user))
    commit('SET_USER_ROLES', localData.set('UserRoles', response.data.roles))
    commit('SET_LOGIN_STATUS', localData.set('LoginStatus', 2))
    resolve(response.data)
  })
}

export default {
  namespaced: true,

  state: {
    loginStatus: localData.get('LoginStatus'),
    sessId: localData.get('SessId'),
    userData: localData.get('UserData'),
    userRoles: localData.get('UserRoles')
  },

  mutations: {
    SET_LOGIN_STATUS(state, loginStatus) {
      state.loginStatus = loginStatus
    },
    SET_SESS_ID(state, sessId) {
      state.sessId = sessId
    },
    SET_USER_DATA(state, userData) {
      state.userData = userData
    },
    SET_USER_ROLES(state, userRoles) {
      state.userRoles = userRoles
    }
  },

  actions: {
    // 设置登录状态
    setLoginStatus({ commit }, query) {
      commit('SET_LOGIN_STATUS', localData.set('LoginStatus', query))
    },

    // 设置用户资料
    setUserInfo({ commit }, userData) {
      commit('SET_USER_INFO', localData.set('UserData', userData))
    },

    // 账户登录
    loginUsername({ commit }, { username, password }) {
      // 请求登录
      const doLogin = () => {
        return loginApi.add({
          loginid: username,
          password
        })
      }

      // 执行操作
      return doLogin().then((response) => afterLogin(commit, response))
    },

    // 使用 sessid 登录
    loginSessid({ commit }, { sessid }) {
      // 请求登录
      const doLogin = () => {
        return loginApi.add({
          sessid
        })
      }

      // 执行操作
      return doLogin().then((response) => afterLogin(commit, response))
    },

    // 登出
    logout({ commit, dispatch }) {
      // 请求退出登录
      const doLogout = () => {
        return logoutApi.add()
      }

      // 退出登录后要做的事
      const afterLogout = (response) => {
        return new Promise((resolve, reject) => {
          if (!response.error) {
            commit('SET_LOGIN_STATUS', localData.set('LoginStatus', -1))
            commit('SET_USER_DATA', localData.remove('UserData'))
            commit('SET_USER_ROLES', localData.remove('UserRoles'))
            resolve()
          } else {
            reject(new Error('退出登录失败：' + response.msg))
          }
        })
      }

      // 执行操作
      return doLogout().then(afterLogout)
    }
  }
}
